// 同意文言詳細
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import axios from '../../../axios';
import { handleBrowserBack } from '../../../BrowserBack';
import { http_status_code_list, maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';
import StaffNavbar from '../../../molecules/StaffNavbar';
import LoadingModal from '../../../molecules/LoadingModal';

interface Clause {
  id: string;
  ja_name: string;
  title: string;
  text: string;
  type: string;
  start_date: string;
  end_date: string;
}

const ClauseDetail = () => {
  // ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(true);
  const [clause, setClause] = useState<Clause>();
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const clause_id = url_params.get('clause_id');

  // グローバルナビゲーション表示用
  const [role, setRole] = useState('');
  const [has_loan_aproval_system, setHasLoanAprovalSystem] = useState(false);
  // 組織区分コードの取得
  const node = document.getElementById('clause-detail');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示する同意文言の取得
    getClause();
    // グローバルナビゲーション表示用
    setUserRole();
  }, []);

  // 選択された同意文言を取得し表示する
  const getClause = async () => {
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_clause`,
        {
          params: {
            clause_id: clause_id,
          },
        }
      );

      if (response.data.result) {
        setClause(response.data.clause);
      } else {
        console.error(response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error.response.data.message);
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // ロールを設定する
  const setUserRole = () => {
    if (node === null) {
      // nodeが正しく取得できない場合は空文字とする
      setRole('');
      setHasLoanAprovalSystem(false);
      return;
    }

    // ロール名をセット
    setRole(node.dataset.role as string);

    // 融資稟議システム導入済みフラグをセット
    if ((node.dataset.has_loan_aproval_system as string) === '1') {
      setHasLoanAprovalSystem(true);
    } else {
      setHasLoanAprovalSystem(false);
    }

    // 組織区分コードをセット
    const user_organization = node?.dataset.organization_type as string;
  };

  // プレビューボタン押下時
  const handlePreview = async () => {
    try {
      setIsLoading(true);

      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/preview_clause`,
        {
          ja_name: clause?.ja_name,
          clause_text: clause?.text,
        }
      );

      if (response.data.result) {
        // 新規タブでプレビュー画面を表示する
        window.open(
          `${location.origin}${process.env.MIX_MOCK_URL}/maintenance/clause_preview`,
          '_blank'
        );
      } else {
        console.error(response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert(error.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <StaffNavbar user_role={role} has_loan_aproval_system={has_loan_aproval_system} />
      <Maintenance active={maintenance_type.clauses}>
        <div className="page-title">同意文言詳細</div>
        {typeof clause === 'object' ? (
          <>
            <table className="detail_table">
              <tbody>
                <tr>
                  <th>JA名</th>
                  <td>{clause.ja_name}</td>
                </tr>
                <tr>
                  <th>同意種類</th>
                  <td>{clause.type}</td>
                </tr>
                <tr>
                  <th>タイトル</th>
                  <td>{clause.title}</td>
                </tr>
                <tr>
                  <th>本文</th>
                  <td className="small_text">
                    ※同意文言の表示はプレビュー画面を開いてご確認下さい
                  </td>
                </tr>
                <tr>
                  <th>開始日</th>
                  <td>{clause.start_date}</td>
                </tr>
                <tr>
                  <th>終了日</th>
                  <td>{clause.end_date}</td>
                </tr>
              </tbody>
            </table>
            <div className="footer-btn">
              <a
                className="btn btn-mini btn-outline-success btn-text-color"
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/clause`}
              >
                戻る
              </a>
              <a
                className="btn btn-mini btn-outline-success btn-text-color"
                onClick={handlePreview}
              >
                プレビュー
              </a>
              <a
                className="btn btn-mini btn-success"
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/clause_edit?clause_id=${clause.id}`}
              >
                編集
              </a>
            </div>
          </>
        ) : (
          <></>
        )}
        <LoadingModal show={is_loading} />
      </Maintenance>
    </>
  );
};

if (document.getElementById('clause-detail')) {
  render(<ClauseDetail />, document.getElementById('clause-detail'));
}
